<template>
  <div>
    <b-row
      align-v="center"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="MeanFitGraphBool"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="MeanFitGraphBool.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="MeanFitGraphExpanded=!MeanFitGraphExpanded"
        >
          <b-icon
            v-if="MeanFitGraphExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="MeanFitGraphBool.value">
      <b-collapse
        v-model="MeanFitGraphExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <TextInputConfiguration
          :controller="MeanRangeMinCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <TextInputConfiguration
          :controller="MeanRangeMaxCtrller"
          :sizeinput="'sm'"
          :forcerow="true"
        />
        <CheckBoxConfiguration
          :controller="StandardAdditionCtrller"
          :switchprop="true"
        />
        <FitSelection
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
        <StatisticalEvaluation
          :sectionconfig="sectionconfig"
          :fitname="fitName"
        />
      </b-collapse>
    </b-row>
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller, fakeInputTextConfCtrller, hiddenConfCtrller} from '@/assets/classes/configuration.js'
import FitSelection from './model/FitSelection'
import StatisticalEvaluation from './StatisticalEvaluation'
import { mapGetters } from 'vuex'

const fitName = 'Ȳ'
const rootContextFolder='ReportViewer/Fit/' + fitName
const zoneNotify='MeanFit'

export default {
  name: 'MeanFit',
  components:{
    FitSelection,
    StatisticalEvaluation,
    CheckBoxConfiguration,
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
    textMainCntller:{
      type:String,
      required: false,
      default:'Mean Fit'
    },
  },
  data() {
    return {
      fitName,
      elementsConfig:[],
      MeanFitGraphBool:new checkBoxGraphConfCtrller(`{0}.${ConfigName.MeanFitDiscreteGraph}`,'Mean Fit',false,rootContextFolder+'Enable',true),
      RangeMeanCtrller:new hiddenConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.range`,[]),
      MeanRangeMinCtrller:new fakeInputTextConfCtrller('','Range Min','Please give a numerical value','0',(value)=>{return !isNaN(value)&& value!==''}),
      MeanRangeMaxCtrller:new fakeInputTextConfCtrller('','Range Max','Please give a numerical value','1',(value)=>{return !isNaN(value)&& value!==''}),
      StandardAdditionCtrller:new checkBoxGraphConfCtrller(`${ConfigName.BaseCurveFit}.${fitName}.StandardAddition`,'Standard Addition',false,rootContextFolder+'StandardAddition'),
			MeanFitGraphExpanded:true,
      isLoading:false
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.elementsConfig = [
      this.MeanFitGraphBool,
      this.RangeMeanCtrller,
      this.MeanRangeMinCtrller,
      this.MeanRangeMaxCtrller,
			this.StandardAdditionCtrller,
    ]
    this.MeanFitGraphBool.textName = this.textMainCntller
    this.configureStudy()
    this.$watch(
      'MeanFitGraphBool.value',
      () => {
        this.verifyConfiguration()
      }
    );
    this.$watch(
      'MeanRangeMinCtrller.value',
      () => {
        this.assembleRangeArray()
      }
    );
    this.$watch(
      'MeanRangeMaxCtrller.value',
      () => {
        this.assembleRangeArray()
      }
    );
  },
  methods:{
    configureStudy(){
      try{
        this.isLoading = true
        this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
        this.MeanFitGraphBool.formatKeyValue(this.sectionconfig)
        this.MeanFitGraphBool.setParent(this)
        this.verifyConfiguration()
        if(this.RangeMeanCtrller.value.length !== 0){
          this.MeanRangeMinCtrller.value = this.RangeMeanCtrller.value[0]
          this.MeanRangeMaxCtrller.value = this.RangeMeanCtrller.value[1]
        }else{
          this.RangeMeanCtrller.value[0] = this.MeanRangeMinCtrller.value
          this.RangeMeanCtrller.value[1] = this.MeanRangeMaxCtrller.value
        }
      }catch(err){
        const errTitle='Error loading Mean Fit'
        const errText=`Error loading Mean Fit for ${this.sectionconfig}. Message: ${err}`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,zoneNotify)
      }finally{
        this.isLoading = false
      }
    },
    verifyConfiguration(){
      if(this.MeanFitGraphBool.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName])!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][fitName]
      }
    },
    assembleRangeArray(){
      if(this.isLoading){
        return
      }
      this.RangeMeanCtrller.setValue([parseFloat(this.MeanRangeMinCtrller.value), parseFloat(this.MeanRangeMaxCtrller.value)])
    }
  }
}
</script>

<style>

</style>